import { useState } from "react";

import type { NotificationFilters } from "../types";

type DateRange = Pick<NotificationFilters, "dateFrom" | "dateTo">;

function toRangeKey({ dateFrom, dateTo }: DateRange) {
  return `${dateFrom ?? ""}|${dateTo ?? ""}`;
}

export function useDateRangePickerKey(range: DateRange) {
  const rangeKey = toRangeKey(range);
  const [state, setState] = useState({ rangeKey, key: 0 });

  if (state.rangeKey !== rangeKey) {
    setState({ rangeKey, key: state.key + 1 });
  }

  const markApplied = (appliedRange: DateRange) => {
    setState((current) => ({ ...current, rangeKey: toRangeKey(appliedRange) }));
  };

  return { pickerKey: state.key, markApplied };
}
